<pw-public-header></pw-public-header>

<div class="page-content-wrapper">
  <router-outlet></router-outlet>
</div>

<div class="footer">
  <div class="row" *ngFor="let container of footerLinks" style="width:100%">
    <div class="col-12" style="width:100%">
      <h3 class="router-links-header" [ngStyle]="{color: container.headerColor}" translate>
        {{container.headerText}}
      </h3>

      <div class="flex pw-language">
        <ng-container *ngFor="let link of container.links">
          <a *ngIf="!link.external; else externalLink" [routerLink]="link.link" [fragment]="link.fragment"
            class="router-link router-link_{{link.arrowType || 'right'}}-arrow" translate>{{link.text}}</a>

          <ng-template #externalLink>
            <a [href]="link.link" class="router-link router-link_{{link.arrowType || 'right'}}-arrow"
              translate>{{link.text}}</a>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>